const autoNgTemplateLoaderTemplate1 = require('./license-info.html');

import controller from './license-info.controller.js';

export const licenseInfo = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: { info: '<' },
};
